var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center"},[_c('div',{staticClass:"text-gray-400 text-3xl mr-3 cursor-pointer fw-600 mt-32"},[_vm._v(" Đang cập nhật ")])])
}]

export { render, staticRenderFns }